import { Email } from '@/components/common/text_input/Email';
import { NewUserJoinedPartnerGroupEmailRequestDto } from '@/models/Admin/Emails/EmailRequestDtos';
import { Autocomplete, Stack, TextField } from '@mui/material';
import React from 'react';
import { PartnerGroupOption } from './types';

type Props = {
  form: NewUserJoinedPartnerGroupEmailRequestDto;
  setForm: React.Dispatch<React.SetStateAction<NewUserJoinedPartnerGroupEmailRequestDto>>;
  partnerGroupAutocompleteOptions: PartnerGroupOption[];
};

const NewUserJoinedPartnerGroupForm: React.FC<Props> = ({
  form,
  setForm,
  partnerGroupAutocompleteOptions,
}) => {
  return (
    <Stack spacing={2}>
      <Email
        fullWidth
        required
        label='Email'
        value={form.Email}
        onChange={(e) => setForm((prev) => ({ ...prev, Email: e.target.value }))}
      />
      <Email
        fullWidth
        required
        label='New User Email'
        value={form.NewUserEmail}
        onChange={(e) => setForm((prev) => ({ ...prev, NewUserEmail: e.target.value }))}
      />
      <Autocomplete
        options={partnerGroupAutocompleteOptions}
        value={
          form.PartnerGroupName.trim() === ''
            ? null
            : (partnerGroupAutocompleteOptions.find(
                (option) => option.partnerGroupName === form.PartnerGroupName
              ) ?? null)
        }
        getOptionLabel={(option) => option.displayLabel}
        isOptionEqualToValue={(option, value) =>
          option.partnerGroupName === value.partnerGroupName &&
          option.partnerGroupId === value.partnerGroupId
        }
        onChange={(_, value) =>
          setForm((prev) => ({
            ...prev,
            PartnerGroupName: value?.partnerGroupName ?? '',
          }))
        }
        renderInput={(params) => <TextField {...params} required label='Partner Group' fullWidth />}
      />
    </Stack>
  );
};

export default NewUserJoinedPartnerGroupForm;
